import logoAddress from 'src/assets/images/dashboard-v3/partners/address.png';
import logoAppikon from 'src/assets/images/dashboard-v3/partners/appikon.png';
import logoBundle from 'src/assets/images/dashboard-v3/partners/bundle.png';
import logoHoney from 'src/assets/images/dashboard-v3/partners/honey.png';
import logoInfluence from 'src/assets/images/dashboard-v3/partners/influence.png';
import logoReviewio from 'src/assets/images/dashboard-v3/partners/reviewio.png';
import logoRichreturn from 'src/assets/images/dashboard-v3/partners/richreturn.png';
import logoUltimate from 'src/assets/images/dashboard-v3/partners/ultimate.png';
import logoViral from 'src/assets/images/dashboard-v3/partners/viral.png';

import AddonColIcon from 'src/assets/images/dashboard-v3/icons-upsell/addon-col.svg';
import AddonRecIcon from 'src/assets/images/dashboard-v3/icons-upsell/addon-rec.svg';
import AddonSearchIcon from 'src/assets/images/dashboard-v3/icons-upsell/addon-search.svg';
import AddonVariantIcon from 'src/assets/images/dashboard-v3/icons-upsell/addon-variant.svg';
import FAnalyticIcon from 'src/assets/images/dashboard-v3/icons-upsell/f-analytic.svg';
import FFilterIcon from 'src/assets/images/dashboard-v3/icons-upsell/f-filter.svg';
import FInstantIcon from 'src/assets/images/dashboard-v3/icons-upsell/f-instant.svg';
import FMerchanIcon from 'src/assets/images/dashboard-v3/icons-upsell/f-merchan.svg';
import FRecIcon from 'src/assets/images/dashboard-v3/icons-upsell/f-rec.svg';
import FSwatchIcon from 'src/assets/images/dashboard-v3/icons-upsell/f-swatch.svg';
import FSynonymIcon from 'src/assets/images/dashboard-v3/icons-upsell/f-synonym.svg';
import StoreIcon from 'src/assets/images/dashboard-v3/icons-upsell/store.svg';

// https://apphub-workspace.slack.com/archives/C06E17VT9RT/p1717056993061469
export const DASHBOARD_V4_EXTERNAL_RELEASE_DATE = '2024-05-30T15:16:00+07:00'

export const DASHBOARD_V4_POSITION = {
  TOP: 0,
  FIRST: 1,
  SECOND: 2
};

export const DASHBOARD_V4_LAYOUT_TOP = () => {
  return [['marketingBanner'], ['welcome3'], ['appInsight'], ['upgradeTurbo']];
};

export const DASHBOARD_V4_LAYOUT_FIRST_COLUMN = ({ isTrial, isFreemium }) => {
  if (isTrial)
    return [
      ['notifications'],
      ['quickStartGuide'],
      ['planSubscription'],
      ['marketingMiddleBanner'],
      ['boostInsightHub']
    ];
  if (isFreemium)
    return [
      ['notifications'],
      ['planSubscription'],
      ['quickStartGuide'],
      ['marketingMiddleBanner'],
      ['boostInsightHub']
    ];
  return [
    ['notifications'],
    ['planSubscription'],
    ['quickStartGuide'],
    ['marketingMiddleBanner'],
    ['boostInsightHub']
  ];
};

export const DASHBOARD_V4_LAYOUT_SECOND_COLUMN = ({ isTrial, isFreemium }) => {
  if (isFreemium) return [['syncHookStatus'], ['getSupport'], ['changeLogs'], ['recommendedApps']];
  if (isTrial) return [['syncHookStatus'], ['getSupport'], ['changeLogs']];
  return [['syncHookStatus'], ['getSupport'], ['changeLogs'], ['recommendedApps']];
};

export const FeaturesKYC = {
  PRODUCT_FILTER: 'PRODUCT_FILTER',
  PRODUCT_SEARCH: 'PRODUCT_SEARCH',
  VISUAL_MERCHANDISING: 'VISUAL_MERCHANDISING',
  PRODUCT_RECOMMENDATION: 'PRODUCT_RECOMMENDATION'
};

export const AI_POWERED_SEARCH = 'AI-powered-search';
export const AI_POWERED_RECOMMENDATION = 'AI-powered-recommendation';
export const COLLECTION_MERCHANDISING = 'collection-merchandising';
export const VARIANT_DISPLAY = 'variant-display';

export const PACKAGE = {
  basic: 'basic',
  essential: 'essential',
  professional: 'professional'
};

export const TYPES = {
  ADD_ON: 'add-on',
  FEATURE: 'feature'
};

export const FEATURES = {
  ANALYTICS: 'Analytics',
  MERCHANDISING: 'Merchandising',
  RECOMMENDATION: 'Recommendation',
  SWATCH_SETTINGS: 'SwatchSettings',
  INSTANT_SEARCH_DISPLAY: 'InstantSearchDisplay',
  AI_SYNONYMS: 'AISynonyms',
  MANAGE_FILTER_TREE: 'ManageFilterTree'
};

export const DEFAULT_MAPPING_UPSELL = {
  // 1 feature, package Basic
  [`${[FeaturesKYC.PRODUCT_SEARCH].join('+')}_${PACKAGE.basic}`]: [
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER].join('+')}_${PACKAGE.basic}`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING].join('+')}_${PACKAGE.basic}`]: [
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_RECOMMENDATION].join('+')}_${PACKAGE.basic}`]: [
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
  ],
  // 1 feature, package Essential
  [`${[FeaturesKYC.PRODUCT_SEARCH].join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER].join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING].join('+')}_${PACKAGE.essential}`]: [
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_RECOMMENDATION].join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  // 1 feature, package Professional
  [`${[FeaturesKYC.PRODUCT_SEARCH].join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER].join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING].join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_RECOMMENDATION].join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],

  // 2 features, package Basic
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH].sort().join('+')}_${PACKAGE.basic}`]:
    [
      { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${
    PACKAGE.basic
  }`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.basic
  }`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${
    PACKAGE.basic
  }`]: [
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.basic
  }`]: [
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.basic
  }`]: [
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
  ],
  // 2 features, package Essential
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH].sort().join('+')}_${
    PACKAGE.essential
  }`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${
    PACKAGE.essential
  }`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.essential
  }`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${
    PACKAGE.essential
  }`]: [
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.essential
  }`]: [
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.essential
  }`]: [
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  // 2 features, package Professional
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH].sort().join('+')}_${
    PACKAGE.professional
  }`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${
    PACKAGE.professional
  }`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.professional
  }`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${
    PACKAGE.professional
  }`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.professional
  }`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${
    PACKAGE.professional
  }`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],

  // 3 features, package Basic
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON }
  ],
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  [`${[
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE }
  ],
  // 3 features, package Essential
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON }
  ],
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON }
  ],
  [`${[
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  // 3 features, package Professional
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],

  // 4 features, package Basic
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE }
  ],
  // 4 features, package Essential
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  // 4 features, package Professional
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ]
};

export const PARTNERS_POWERUP = [
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_reviewio_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_reviewio_description',
    logo: logoReviewio,
    link: 'https://apps.shopify.com/reviews-co-uk-product-and-merchant-review-collection'
  },
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_influence_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_influence_description',
    logo: logoInfluence,
    link: 'https://apps.shopify.com/influence-io'
  },
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_viral_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_viral_description',
    logo: logoViral,
    link: 'https://apps.shopify.com/viralsweep'
  },
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_address_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_address_description',
    logo: logoAddress,
    link: 'https://apps.shopify.com/address-validator'
  },
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_richreturn_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_richreturn_description',
    logo: logoRichreturn,
    link: 'https://apps.shopify.com/rich-returns'
  },
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_honey_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_honey_description',
    logo: logoHoney,
    link: 'https://apps.shopify.com/honeycomb-upsell-funnels'
  },
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_appikon_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_appikon_description',
    logo: logoAppikon,
    link: 'https://apps.shopify.com/pre-order-today'
  },
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_bundle_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_bundle_description',
    logo: logoBundle,
    link: 'https://apps.shopify.com/bundles-bear'
  },
  {
    title: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_ultimate_title',
    description: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_ultimate_description',
    logo: logoUltimate,
    link: 'https://apps.shopify.com/ultimate-sticky-add-to-cart?st_source=autocomplete'
  }
];

export const DATA_UPSELL = {
  [AI_POWERED_SEARCH]: {
    icon: AddonSearchIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonSearch',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonSearch_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonSearch_btn',
    isHasAI: true
  },
  [AI_POWERED_RECOMMENDATION]: {
    icon: AddonRecIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonRec',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonRec_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonRec_btn',
    isHasAI: true
  },
  [COLLECTION_MERCHANDISING]: {
    icon: AddonColIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonCol',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonCol_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonCol_btn',
    isHasAI: false
  },
  [VARIANT_DISPLAY]: {
    icon: AddonVariantIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonVariant',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonVariant_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonVariant_btn',
    isHasAI: false
  },
  [FEATURES.ANALYTICS]: {
    icon: FAnalyticIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FAnalytic',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FAnalytic_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FAnalytic_btn',
    isHasAI: false
  },
  [FEATURES.MERCHANDISING]: {
    icon: FMerchanIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FMerchan',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FMerchan_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FMerchan_btn',
    isHasAI: false
  },
  [FEATURES.RECOMMENDATION]: {
    icon: FRecIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FRec',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FRec_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FRec_btn',
    isHasAI: false
  },
  [FEATURES.SWATCH_SETTINGS]: {
    icon: FSwatchIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSwatch',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSwatch_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSwatch_btn',
    isHasAI: false
  },
  [FEATURES.INSTANT_SEARCH_DISPLAY]: {
    icon: FInstantIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FInstant',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FInstant_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FInstant_btn',
    isHasAI: false
  },
  [FEATURES.AI_SYNONYMS]: {
    icon: FSynonymIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSynonym',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSynonym_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSynonym_btn',
    isHasAI: true
  },
  [FEATURES.MANAGE_FILTER_TREE]: {
    icon: FFilterIcon,
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FFilter',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FFilter_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FFilter_btn',
    isHasAI: false
  }
};

export const DATA_UPSELL_ITEM_STORE = {
  name: 'store',
  icon: StoreIcon,
  title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.Store',
  label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.Store_label',
  btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.Store_btn'
};